/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  Autocomplete
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateUserAdd } from '../../assets/validation';
import UserAction from '../../store/actions/UserAction';
import DeptAction from '../../store/actions/DepartmentAction';
import RolePermAction from '../../store/actions/RolePermAction';
// import { technologyAction } from "../../../redux/actions/technologyAction";

function UserAdd({ openmodal, onCloseModal }) {
  const { activeDeptData } = useSelector((state) => state.department);
  const { activeRoleData } = useSelector((state) => state.rolePermission);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(DeptAction.getActiveItem());
    dispatch(RolePermAction.getActiveItem());
  }, [dispatch]);

  console.log(activeRoleData, 'activeRoleData');

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            name: '',
            email: '',
            department: null,
            role: null
          }}
          // enableReinitialize
          validationSchema={ValidateUserAdd}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            const newValues = {
              ...values,
              email: (values.email || '').trim().toLowerCase()
            };
            if (values.department?._id) {
              newValues.department = values.department._id;
            }
            if (values.role?._id) {
              newValues.role = values.role._id;
            }
            dispatch(UserAction.add(newValues, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Add User"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="User Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter User Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    // onBlur={handleBlur}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="email"
                    type="email"
                    fullWidth
                    label="Email ID"
                    name="email"
                    margin="normal"
                    placeholder="Enter Email ID"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.email && touched.email}
                    helperText={errors.email && touched.email && errors.email}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-email" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <Field
                    name="department"
                    component={Autocomplete}
                    className="CurrencyField"
                    options={activeDeptData ?? []}
                    value={values.department}
                    // isOptionEqualToValue={(option, value) => option.name === value.name}
                    filterSelectedOptions
                    // disableClearable
                    onChange={(e, newvalue) => {
                      setFieldValue('department', newvalue);
                      // if (newvalue && newvalue._id) {
                      //   setFieldValue('department', newvalue._id);
                      // }
                    }}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="department"
                        error={touched.department && !!errors.department}
                        helperText={touched.department && errors.department}
                        label="Department Name"
                        placeholder="Search Department"
                        variant="outlined"
                        margin="normal"
                        required={false}
                        InputLabelProps={{ required: true }}
                        // SelectProps={{
                        //   IconComponent: ExpandMore
                        // }}
                      />
                    )}
                  />
                  <Field
                    name="role"
                    component={Autocomplete}
                    className="CurrencyField"
                    value={values.role}
                    options={activeRoleData ?? []}
                    // isOptionEqualToValue={(option, value) => option.name === value.name}
                    filterSelectedOptions
                    // disableClearable
                    onChange={(e, newvalue) => {
                      setFieldValue('role', newvalue);
                      // if (newvalue && newvalue._id) {
                      //   setFieldValue('role', newvalue._id);
                      // }
                    }}
                    // loading={isLoading}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="role"
                        error={touched.role && !!errors.role}
                        helperText={touched.role && errors.role}
                        label="Role Name"
                        placeholder="Search Role"
                        variant="outlined"
                        margin="normal"
                        // SelectProps={{
                        //   IconComponent: ExpandMore
                        // }}
                      />
                    )}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

UserAdd.propTypes = {
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default UserAdd;
